import React, { useEffect, useRef, useState } from 'react'
import { formFieldDataP2 } from '../../../../core/data/json/DistrictAPMC';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SingleView from './SingleView';
import { getExistedSchemesAplication, queryFormApplication, updateField } from '../../../auth/services/privateapicalling';
import { toast } from 'react-toastify';
import ActionButtons from './ActionButtons';
import { roleOptions } from '../../../../core/data/json/role';

interface APMCp2Props {
  setExistData:any,
  applicationId:any,

  onNext: () => void;
  onBack: () => void;
  formData: any;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement> , documentName: string) => Promise<string>;
  handlePreviewFile: (fileData:any) => void;
  editingIndex: number | null;
  setEditingIndex: (index: number | null) => void;
  editFieldValues: { [key: string]: any };
  handleEditChange: (name: string, value: any) => void;
  editFiles: { [key: string]: File | null };
  handleEditFileChange: (name: string, file: File | null) => void;
  editComment: string;
  setEditComment: (comment: string) => void;
  // handleUpdateSubmit: (index: number, responses: any[] , updatedFields:any) => void;
  updatedFields:any;
  setUpdatedFields:any,
   existData:any,
  userDetail:any,
  token:any,
  getExistedApplication:() => void;
  validationErrors: { [key: string]: boolean };
  setValidationErrors: (errors: { [key: string]: boolean } | ((prev: { [key: string]: boolean }) => { [key: string]: boolean })) => void;
  isValidationActive: boolean;
  setIsValidationActive: (active: boolean) => void;
}


const DistP2 = ({
        setExistData,
        applicationId,

  token,
  onNext,
  onBack,
  formData,
  handleFileChange,
  handlePreviewFile,
  editingIndex,
  setEditingIndex,
  editFieldValues,
  handleEditChange,
  editFiles,
  handleEditFileChange,
  editComment,
  setEditComment,
  // handleUpdateSubmit,
  updatedFields,
  setUpdatedFields,

   existData,
  userDetail,
  getExistedApplication,
  validationErrors,
  setValidationErrors,
  isValidationActive,
  setIsValidationActive,

}: APMCp2Props) => {

  

  const roleIdentifier = userDetail.Role.Role_Identifier;
  //---------------------------------Validation----------------------------------

const validateActionButtons = () => {
  const errors: { [key: string]: boolean } = {};
  
  // Check each field that requires action
  formFieldDataP2.forEach((item, index) => {
    // Skip fields that don't need validation (adjust field numbers as needed for P2)
 

    const fieldAction = fieldActions[index];
   const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;


// Check if field was already submitted in existData
let isFieldSubmittedInExistData = false;

item.response.forEach((r) => {
  const reSubmittedFieldsData = existData?.apmcSchemeTransaction?.rejectedFields?.rejectedFieldsData?.annexureTwo;
  const transactions = existData.annexureTwo?.[r.fieldName]?.transaction || [];
  let lastRoleTx = null;
 const shouldCheckResubmission = existData?.appStatusLevel !== 'pendingAtHigherAuthorityApproval';
  if (shouldCheckResubmission && reSubmittedFieldsData && Object.prototype.hasOwnProperty.call(reSubmittedFieldsData, r.fieldName)) {
    // If resubmitted field, only set lastRoleTx if the last transaction is for this role
    if (transactions.length > 0) {
      const lastTx = transactions[transactions.length - 1];
      if (lastTx.transactionBy === roleIdentifier) {
        lastRoleTx = lastTx;
      }
    }
  } else {
    // Not a resubmitted field: filter by role as before
    lastRoleTx = transactions.filter(
      (tx) => tx.transactionBy === roleIdentifier
    ).pop();
  }

  if (lastRoleTx) {
    if (lastRoleTx.isVerified === true || 
        lastRoleTx.isUpdated === true || 
        (lastRoleTx.comment && lastRoleTx.comment.trim() !== '')) {
      isFieldSubmittedInExistData = true;
    }
  }
});

    // Field has error if it's not submitted and has no current action
    if (!isFieldSubmittedInExistData && !fieldAction?.submitted) {
      errors[`field_${index}`] = true;
    }
  });

  setValidationErrors(errors);
  return Object.keys(errors).length === 0;
};

//----------------------------------Field Open Logic----------------------------------
  

  const [logFieldKey, setLogFieldKey] = useState<string | null>(null);
  
  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  
  const [showLogOverlay, setShowLogOverlay] = useState(false);
    const [transactionData, setTransactionData] = useState([]);
  
    const [touched, setTouched] = useState<{ [key: string]: boolean }>({});
   const [fieldActions, setFieldActions] = useState<{ [key: number]: {
      verified: boolean;
      updated: boolean;
      comment: string;
      updateData: any;
      submitted?: boolean;
    } }>({});
  const fieldChangeLogs: { [key: string]: any[] } = {
  // add more as needed
  permissionFromAuthority:[
    {
      user: "Priyansh",
      from: "One File",
      to: "Two File",
      comment: "File Was not correct",
      time: "2024-03-02 12:05 PM",
    },
    {
      user: "Pranav",
      from: "Two File",
      to: "Three File",
      comment: "Second File Was not correct",
      time: "2024-03-02 12:05 PM",
    },
  ],
  insuranceUndertakingPostConstruction:[
    {
      user: "Pranav",
      from: "Tools File",
      to: "No tools",
      comment: "File Was having weapons",
      time: "2024-03-02 12:05 PM",
    },
  ]
};
const handleViewLogClick = (fieldKeys: string[] | string) => {

  // const keys = Array.isArray(fieldKeys) ? fieldKeys : [fieldKeys];
    const keys = Array.isArray(fieldKeys) ? fieldKeys : [fieldKeys];
   
    
    const transactionData = keys.map(key => ({
      key,
      data: existData.annexureTwo?.[key]?.transaction || []
    }));

    setTransactionData(transactionData)
setShowLogOverlay(true);
    setLogFieldKey(keys.join(", "));
};



  const handleCloseOverlay = () => {
    setShowLogOverlay(false);
  };

 const handleVerifiedChange = (fieldIndex: number) => {
    setFieldActions(prev => ({
      ...prev,
      [fieldIndex]: {
        ...prev[fieldIndex],
        verified: !prev[fieldIndex]?.verified,
        updated: prev[fieldIndex]?.updated || false,
        comment: prev[fieldIndex]?.comment || "",
        updateData: prev[fieldIndex]?.updateData || {},
        submitted: prev[fieldIndex]?.submitted || false
      }
    }));
  };

    const handleUpdateData = (fieldIndex: number, updateData: any) => {
    // Only set updated to true if there's actual data in updateData
    const hasActualData = Object.values(updateData).some(value => 
      value !== null && value !== undefined && value !== ""
    );

    setFieldActions(prev => ({
      ...prev,
      [fieldIndex]: {
        ...prev[fieldIndex],
        verified: prev[fieldIndex]?.verified || false,
        updated: hasActualData, // Only true if there's actual data
        comment: prev[fieldIndex]?.comment || "",
        updateData: updateData,
        submitted: prev[fieldIndex]?.submitted || false
      }
    }));
  };

  const handleCommentChange = (fieldIndex: number, comment: string) => {
   
    setFieldActions(prev => ({
      ...prev,
      [fieldIndex]: {
        ...prev[fieldIndex],
        verified: prev[fieldIndex]?.verified || false,
        updated: prev[fieldIndex]?.updated || false,
        comment: comment,
        updateData: prev[fieldIndex]?.updateData || {}
      }
    }));
  };


const [showErrors, setShowErrors] = useState(false);


//----------------------------------File Function--------------------------------
const fileButtonFn = (fieldName , docName) => {
 
  const docData = existData?.annexureTwo?.[fieldName];
  const docId = docData?.data.find(data=>data.documentName == docName)?.docId;
  

  return (
    <Link
    to="#"
    data-bs-toggle="modal"
    data-inert={true}
    data-bs-target="#apmc_modal"
    className="btn btn-outline-info w-100 align-items-center"
    onClick={() => {
      setSelectedDocId(docId);
    
    }}
  >
    <i className="ti ti-eye"></i> View Document
  </Link>
  );
};




// )------------------------------BUTTONS FOR ACTIONS (verify, edit, comment)------------------------------
// 6. ENHANCED ACTION BUTTONS WITH CONDITIONAL ACTION REQUIRED PARAGRAPH


   const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
      setTouched(prev => ({ ...prev, [e.target.name]: true }));
    };
  

//----------------------------------Next button----------------------------------

const [rowErrors, setRowErrors] = useState<{ [key: number]: boolean }>({});

const handleNextClick = () => {
if(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"&&roleIdentifier===existData?.role&&existData?.appStatusLevel!=="hoclerkAfterApproveAction")
   { const isValid = validateActionButtons();
  setIsValidationActive(true);

  if (!isValid) {
    // Scroll to first error field
    const firstErrorField = Object.keys(validationErrors)[0];
    if (firstErrorField) {
      const fieldIndex = firstErrorField.replace('field_', '');
      const element = document.getElementById(`actionButtons_${fieldIndex}`);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }
    }
    
    toast.error("Please complete all required actions before proceeding", {
      position: "top-right"
    });
    return;
  }

  // Reset validation state on successful validation
  setIsValidationActive(false);
  setValidationErrors({});}
  // const newErrors: { [key: number]: boolean } = {};
  // const incompleteFields: string[] = [];

  // formFieldDataP2.forEach((item, index) => {
  //   const isVerified = verified[index];
  //   const isUpdated = updatedIndexes.includes(index);
    
  //   // Field must be either verified OR updated
  //   if (!isVerified && !isUpdated) {
  //     newErrors[index] = true;
  //     incompleteFields.push(`Field ${index + 1}`);
  //     // incompleteFields.push(`Field ${index + 1}: ${item.fieldVal}`);
  //   }
  // });

  // setRowErrors(newErrors);

  // if (Object.keys(newErrors).length === 0) {
  //   onNext();
  // } else {
    // Show a more informative error message
    // alert(`Please complete the following fields by either verifying or updating them:\n\n${incompleteFields.join('\n')}`);
    onNext();
  // }
};



  // Add state for verified checkboxes
  const [verified, setVerified] = useState<{ [key: string]: boolean }>({});
  const [updatedIndexes, setUpdatedIndexes] = useState<number[]>([]);






 const tempgetExistedApplication = async () => {
     try {
   
          const response = await getExistedSchemesAplication(token, applicationId, existData.scheme.id);
      
          if (response?.success) {
          
             setExistData(response?.data);
          }
        } catch (error) {
      
        }
      }


  function buildResponseMap(jsonData) {
    return jsonData
      .flatMap(field => field.response)
      .reduce((acc, resp) => {
        acc[resp.responseVal] = resp.responseName;
        return acc;
      }, {});
  }
  const responseMap = buildResponseMap(formFieldDataP2);
const handleUpdateSubmit = async (index: number, responses: any[]) => {
  // const item = formFieldDataP2[index];
  
  // Validate required fields for update
  const missingFields: string[] = [];
  const missingFiles: string[] = [];

  responses.forEach((r) => {
    const key = r.responseVal;
    
    if (r.responseType === "file" || r.responseType === "button") {
      // Check if file is uploaded (either in formData or editFiles)
      const hasOriginalFile = formData[key];
      const hasNewFile = editFiles[key];
      
      if (!hasOriginalFile && !hasNewFile) {
        missingFiles.push(r.responseName || key);
      }
    } else {
      // Check other field types
      const value = editFieldValues[key] || formData[key];
      if (!value && r.required !== false) {
        missingFields.push(r.responseName || key);
      }
    }
  });

  // Validate comment is provided for update
  // if (!editComment.trim()) {
  //   alert("Please provide a comment for the update.");
  //   return;
  // }

  // Show validation errors
  // const allMissingFields = [...missingFields, ...missingFiles];
  // if (allMissingFields.length > 0) {
  //   alert(`Please fill required fields: ${allMissingFields.join(", ")}`);
  //   return;
  // }
  
const fieldAction = fieldActions[index];
    if (!fieldAction) {
   
      return;
    }
  // If validation passes, proceed with update


  // Your existing update logic continues here...
  const transactionBy = roleIdentifier;
  const status = existData.status;
  // const comment = editComment;
  const oldValue: any[] = [];
  const newValue: any[] = [];
  let isFieldUpdated = false;

  const field = responses.find(res => res.fieldName)?.fieldName;

   if(Object.keys(updatedFields).length > 0){

    isFieldUpdated=true;
 
    Object.entries(fieldAction.updateData).forEach(([fieldKey, updatedVal]: any) => {
      const fieldDataArray = existData?.annexureTwo?.[field]?.data;
     
      if (!Array.isArray(fieldDataArray)) return;

      let matched;

      if (updatedVal?.docId && updatedVal?.documentName) {
        
        matched = fieldDataArray.find(
          (item: any) =>
            item?.documentName === updatedVal.documentName && item?.docId !== updatedVal.docId
        );

      

        if (matched) {
          oldValue.push({
            fieldValue: matched.docId || "",
            fieldName: matched.documentName,
            fileName: matched.fileName,
            fieldType: "doc"
          });
        }
        else{
           oldValue.push({
            fieldValue: matched.docId || "",
            fieldName: updatedVal.documentName,
            fileName: matched.fileName,
            fieldType: "doc"
          });
        }

        newValue.push({
          fieldValue: updatedVal.docId,
          fieldName: updatedVal.documentName,
          fileName:updatedVal.fileName,
          fieldType: "doc"
        });
      } else {
        matched = fieldDataArray.find(
          (item: any) => item?.fieldName === fieldKey
        );

        if (matched) {
          oldValue.push({
            fieldValue: matched?.value || "",
            fieldName: matched?.fieldName,
            fieldType: "string"
          });
        }

        newValue.push({
          fieldValue: updatedVal,
          fieldName: fieldKey,
          fieldType: "string"
        });
      }
    });
  }
     if(fieldAction?.comment.trim()=="" &&isFieldUpdated) 
      {
        toast.warn('comment is mandatory while updation',{position:"top-right"});
        return;
      }


  const transaction = [{
    oldValue,
    newValue,
    transactionBy: roleIdentifier,
    status: existData.status,
    appStatusLevel: existData.appStatusLevel,
   
  }];

  const payload = {
    couchId: existData?.applicationDataId,
    fieldUpdated: field,
    applicationType:"scheme",
    annexureUpdated: "annexureTwo",
    isVerified: isFieldUpdated?false:fieldAction.verified,
     isUpdated:isFieldUpdated,
      comment: fieldAction.comment,
    [`${field}`]: {
      transaction
    }
  };

  

  try {
    const submitTransaction = await updateField(payload, token);


    if (submitTransaction?.result?.ok) {
      setEditingIndex(null);
      toast.success(
                <>
                  Field Transaction submitted successfully <br />
                  ફીલ્ડ સફળતાપૂર્વક સબમિટ કરવામાં આવ્યું
                </>,
                {
                  position: "top-right",
              
                }
              );
      
      // Update the field action to mark as submitted instead of clearing it
      setFieldActions(prev => ({
        ...prev,
        [index]: {
          ...prev[index],
          submitted: true  // Add this flag to indicate submission is complete
        }
      }));
      
      // ADD THESE NEW LINES FOR VALIDATION
      // Clear validation error for this field
      setValidationErrors(prev => {
        const updated = { ...prev };
        delete updated[`field_${index}`];
        return updated;
      });
      
      setUpdatedFields({})
      tempgetExistedApplication();
    } else {
   
      toast.error('Update failed. Please try again.',{position:"top-right"});
    }
  } catch (error) {
   
    toast.error('An error occurred during update. Please try again.',{position:"top-right"});
  }
};

 const handleDirector = async (fieldsToUpdate: any[]) => {
    try {
      if (!fieldsToUpdate || fieldsToUpdate.length === 0) return;
  //  setSubmitLoading(true);
      const payload = {
        couchId: existData?.applicationDataId,
        applicationType: "scheme",
        fieldsToUpdate: fieldsToUpdate
      };

      

      // Call the API
      const response = await queryFormApplication(payload, token);

      if (response?.dbResult?.ok) {
        toast.success(
                 <>
                   Field Transaction submitted successfully <br />
                   ફીલ્ડ સફળતાપૂર્વક સબમિટ કરવામાં આવ્યું
                 </>,
                 {
                   position: "top-right",
                   
                 }
               );
      getExistedApplication();
      } else {
       
      }
        
    } catch (error) {
      
     
    } finally {
    // setSubmitLoading(false)
    }
  };

   useEffect(() => {
    
    
        if (!existData || !existData.annexureTwo || !formFieldDataP2) return;
    
        const newVerified: { [key: number]: boolean } = {};
        const newUpdatedIndexes: number[] = [];
        const newComments: { [key: string]: string } = {};
    
        formFieldDataP2.forEach((item, index) => {
          let isVerifiedForRole = false;
          let isUpdatedForRole = false;
          let commentForRole: string | null = null;
    
          item.response.forEach((r) => {
            const reSubmittedFieldsData = existData?.apmcSchemeTransaction?.rejectedFields?.rejectedFieldsData?.annexureTwo;
            const transactions = existData.annexureTwo?.[r.fieldName]?.transaction || [];
            let lastRoleTx = null;
            const shouldCheckResubmission = existData?.appStatusLevel !== 'pendingAtHigherAuthorityApproval';
            if (shouldCheckResubmission&&reSubmittedFieldsData && Object.prototype.hasOwnProperty.call(reSubmittedFieldsData, r.fieldName)) {
              // If resubmitted field, only set lastRoleTx if the last transaction is for this role
              if (transactions.length > 0) {
                const lastTx = transactions[transactions.length - 1];
                if (lastTx.transactionBy === roleIdentifier) {
                  lastRoleTx = lastTx;
                }
              }
            } else {
              // Not a resubmitted field: filter by role as before
              lastRoleTx = transactions.filter(
                (tx) => tx.transactionBy === roleIdentifier
              ).pop();
            }
    
            if (lastRoleTx) {
              if (lastRoleTx.isVerified === true) {
                isVerifiedForRole = true;
              }
              if (lastRoleTx.isUpdated === true) {
                isUpdatedForRole = true;
              }
            if (lastRoleTx.comment) {
  const shouldAssignComment = 
    existData.appStatusLevel === "pendingAtHigherAuthorityLevel"
      ? lastRoleTx.appStatusLevel === "pendingAtHigherAuthorityLevel"
      : true;
  
  if (shouldAssignComment) {
    commentForRole = lastRoleTx.comment;
  }
}
            }
          });
    
          if (isVerifiedForRole) {
            newVerified[index] = true;
          }
          if (isUpdatedForRole) {
            newUpdatedIndexes.push(index);
          }
          if (commentForRole) {
            newComments[item.fieldName] = commentForRole;
          }
            setFieldActions(prev => ({
          ...prev,
          [index]: {
            ...prev[index],
            verified: newVerified[index] || false,
            updated: prev[index]?.updated || false,
            comment: newComments[item?.fieldName] || "",
            updateData: prev[index]?.updateData || {},
            submitted:(newVerified[index])
           
          }
        }));
    
        });
    
        
      }, [existData, roleIdentifier]);
  // ensure this runs once when required data becomes available
  const autoVerifyDoneRef = useRef(false);

  useEffect(() => {
    // avoid running multiple times
    if (autoVerifyDoneRef.current) return;

    // Wait until we have the data and role info
    if (!existData || !existData.annexureTwo || !formFieldDataP2 || !roleIdentifier) return;

    const isDirector = roleIdentifier === "DT";
    const isDistrictRegistrar = roleIdentifier === "Dr";
    if (!isDirector && !isDistrictRegistrar) return;

    const newVerified: { [key: number]: boolean } = {};
    const verifiedFieldsToUpdate: any[] = [];

    // Director should auto-verify fields verified by Deputy Director (DY)
    // District Registrar should auto-verify fields verified by Committee (COM)
    const verifierRoleIdentifier = isDirector ? "DY" : "COM";

    formFieldDataP2.forEach((item, index) => {
      let isVerifiedByPrevious = false;

      item.response.forEach((r) => {
        const transactions = existData.annexureTwo?.[r.fieldName]?.transaction || [];

        const prevVerified = transactions.some(
          (tx) => tx.transactionBy === verifierRoleIdentifier && tx.isVerified === true
        );

        if (prevVerified) {
          isVerifiedByPrevious = true;
        }
      });

      if (isVerifiedByPrevious) {
        newVerified[index] = true;

        verifiedFieldsToUpdate.push({
          fieldUpdated: item.fieldName,
          annexureUpdated: "annexureTwo",
          newTransaction: {
            transactionBy: userDetail?.Role?.Role_Identifier,
            status: "pending",
            appStatusLevel: existData?.appStatusLevel,
            newValue: []
          },
          isVerified: true,
          isUpdated: false,
          comment: ""
        });
      }

      setFieldActions(prev => ({
        ...prev,
        [index]: {
          ...prev[index],
          verified: newVerified[index] || false,
          updated: prev[index]?.updated || false,
          comment: prev[index]?.comment || "",
          updateData: prev[index]?.updateData || {},
          submitted: true
        }
      }));
    });

    if (verifiedFieldsToUpdate.length > 0) {
      handleDirector(verifiedFieldsToUpdate);
    }

    // mark done so it doesn't re-run
    autoVerifyDoneRef.current = true;

    // Run when the data or role become available; but only once because of the ref
  }, [existData, roleIdentifier, formFieldDataP2]);



  return (
    <>
    <div className='w-100 d-flex align-items-end justify-content-end px-5'>
      <div className="w-100">
                <div className='d-flex flex-column text-nightblue align-items-center justify-content-center  '>
                  <div id='table' className='w-100 border overflow-hidden bg-white border-secondary rounded mb-5'>
        
                    <div id='head' className='d-flex w-100  rounded-top border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                        <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                        <h4 className='col-4 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                        <div className='col-7 d-flex justify-content-center align-items-center'>
                    <h4
     className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
  (existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"))
    ? "col-4"
    : "col-8"
}`}

    >
      જવાબ (Response)
    </h4>

    {(existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ")) && (
      <h4 className="col-4 p-2 justify-content-center d-flex align-items-center border-end border-secondary">
        ક્રિયા (Action)
      </h4>
    )}
      <h4 className="col-4 p-2 justify-content-center d-flex align-items-center  border-secondary">
                  Change History
                </h4>
                        </div>
                    </div>
                      <div className='d-flex border-top border-secondary'>
                      <h4 className='col-1 d-flex align-items-center justify-content-center '>09.</h4>
                      <p className=' border-start border-secondary p-2'>નીચે મુજબની બાંહેધરીઓ / પ્રમાણપત્રો (Following undertakings/certificates to be submitted:)</p>
                    </div>
                    {formFieldDataP2 && formFieldDataP2.length > 0 &&
                    formFieldDataP2.map((item,index)=>{

                  //---------------------If 0 change then No click-------------------------------
                      const changeCount = item.response.reduce((total, r) => {
                        return total + (fieldChangeLogs[r.responseVal]?.length || 0);
                      }, 0);
                      return(
                        <React.Fragment key={index}>
                          <div className={`d-flex border-top border-secondary ${(() => {
                            const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;
                              if (!fieldName) return '';
                              
                              const annexureField = existData?.annexureTwo?.[fieldName];
                              const hasSubmittedUpdates = annexureField?.transaction?.some(
                                (txn) => (txn?.isUpdated === true && txn?.transactionBy == roleIdentifier)
                                // || txn?.comment.trim() !== ""
                                //For comment to show
                              ) ?? false;
                              
                              return hasSubmittedUpdates ? 'bg-body-tertiary' : '';
                            })()}`
                            
                            }
                            key={index}
                            >
                            <h4 className='col-1'></h4>
                            {/* <h4 className='col-1  d-flex align-items-center justify-content-center'></h4> */}
                            <div className='col-4 d-flex gap-2 border-start border-end border-secondary '>
                              <h4 className='col-2 d-flex align-items-center justify-content-center border-end border-secondary'>{index<9?`0${index + 1}.`:`${index + 1}.`}</h4>
                              <p className='w-100 p-2 '>{item.fieldVal}*</p>
                            </div>
                            
                 <div className='col-7 d-flex'>
                      <div className={`col-4 d-flex border-end border-secondary flex-column p-2 gap-2 align-items-center justify-content-center ${
  (existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"))
    ? "col-4"
    : "col-8"
}`}>
                                {item.response.map((newObj, indx) => {
                                  const fieldName = newObj.responseVal;
                                  const docName = newObj.responseVal;
                                  const inputKey = `${index}_${indx}`;
                                  const divVal = 
                                    newObj.responseType === "button" ? fileButtonFn(fieldName, docName) :
                                    null;

                                  return (
                                    <div className="w-75" key={inputKey}>
                                      {divVal}
                                    </div>
                                  );
                                })}

                              </div>
                          {   (existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"))  &&  <div className='col-4 d-flex p-2 gap-2 border-end border-secondary flex-column align-items-center justify-content-center'>
                                <div className='d-flex flex-row gap-2'>  
                            <ActionButtons
                            existData={existData}
                            fieldNo={`${index}`} 
                            item={item}
                            fieldActions={fieldActions}
                            editingIndex={editingIndex}
                            setEditingIndex={setEditingIndex}
                            onVerifiedChange={handleVerifiedChange}
                            onCommentChange={handleCommentChange}
                            onUpdateSubmit={handleUpdateSubmit}
                            updatedFields={updatedFields} 
                            annexureType="annexureTwo" 
                            userDetail={userDetail}
                            isValidationActive={isValidationActive}
                            hasValidationError={validationErrors[`field_${index}`] || false}
                            fieldIndex={index}
                          />
                                </div>
                              </div>}

                    <div className='col-4 d-flex p-2 gap-2 flex-column flex-lg-row align-items-center justify-content-center'>
                      <div className='border rounded-3 ps-2'>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip >
                                See the edit history for this field
                              </Tooltip>
                            }
                          >
                            <i className="feather feather-info pe-2"></i>
                          </OverlayTrigger>
                        {/* {
                          (() => {
                            //  const totalLogs = Object.values(fieldChangeLogs).reduce((sum, logs) => sum + logs.length, 0);
                            const fieldKey = item.response[0]?.responseVal;
                            const logCount = fieldChangeLogs[fieldKey]?.length || 0;
                            return `${logCount} Change${logCount !== 1 ? "s" : ""}`;
                          })()
                        } */}
                       
                        {/* <button
                          className='btn btn-light rounded-3 ms-2'
                          onClick={() =>
                            handleViewLogClick(item.response.map((r) => r.responseVal))
                          }
                          disabled={changeCount === 0}
                        >
                          View Log
                        </button> */}
                                  {(() => {
        
        const fieldName = item.response.find(r => r?.fieldName)?.fieldName;
        const annexureField = existData?.annexureTwo?.[fieldName];

      
        // const hasTransaction = annexureField?.transaction && annexureField.transaction.length > 0;
        const hasValidTransaction =
          annexureField?.transaction?.some(
            (txn) =>
               txn?.comment.trim() !== ""
          ) ?? false;

        return (
          <button
            className={`btn rounded-3 ms-2 ${hasValidTransaction ? "btn-primary" : "btn-light"}`}
            onClick={() =>
              handleViewLogClick(
                fieldName
                  ? fieldName
                  : (item.response.find((r) => r?.responseVal)?.responseVal)
              )
            }
          >
            View Log
          </button>
        );
      })()}
                      </div>

                    </div>
                            </div>
                          </div>
                          {editingIndex === index && (
                            <div className="d-flex flex-column border-top border-secondary bg-white p-3">
                              <h4 className='border-bottom border-3 border-success mb-3'>Edit Values and Comment</h4>

                              {/* 🔹 Row 1: File Inputs */}
                              <div className="d-flex gap-3 flex-wrap mb-3">
                                {item.response
                                  .filter(r => r.responseType === "file" || r.responseType === "button")
                                  .map((r, fileIdx) => (
                                            <input className='form-control w-75' 
                                            type='file'  
                                            onChange={async(e) => {
                                            const response = await  handleFileChange(e, `${r.fieldName}`);
                                              // Update the field action with file data
                                             
                                              
                                              if (e.target.files && e.target.files[0] && response) {
                                                
                                                  const updatedDocId=response;

                                                  handleUpdateData(index, {
                                                    ...fieldActions[index]?.updateData,
                                                    [r.fieldName]: {
                                                      docId: updatedDocId, 
                                                      documentName: r.responseVal,
                                                      fileName:e.target.files[0].name
                                                    }
                                                  });
                                              }
                                            }}
                                            name={`${r.responseVal}`}  
                                            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                                            id='uploadPlan' 
                                            onBlur={handleBlur}
                                          />
                                  ))}
                              </div>

                            </div>
                          )}
                          </React.Fragment>
                      )
                    })}
         
                  </div>
                </div>
        <div className="d-flex justify-content-end gap-2 mb-3 me-5">
            <button className="btn btn-secondary" onClick={onBack}>Back</button>
            <button className="btn btn-info" onClick={handleNextClick}>Next</button>
        </div>
      </div>
      </div>

      
      {showLogOverlay && (
             <div
               className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
               style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 1055 }}
             >
               <div
                 className="bg-white p-4 rounded shadow position-relative overflow-auto"
                 style={{ minWidth: "70%", maxHeight: "90%", maxWidth: "800px" }}
               >
                 <button
                   className="position-absolute top-0 end-0 m-3 btn-close"
                   onClick={handleCloseOverlay}
                 />
           
                 <div className="d-flex align-items-center gap-2 mb-3">
                   <i className="ti ti-history"></i>
                   <h4 className="mb-0">Change History - {formFieldDataP2.find((f: any) => f.fieldName === logFieldKey)?.fieldLabel || logFieldKey}</h4>
                 </div>
           
                 {/* Transaction Section */}
                 {transactionData?.length > 0 && (
                   <div className="mt-4">
                     <div className="d-flex align-items-center gap-2 mb-3">
                       <i className="ti ti-report"></i>
                       <h5 className="mb-0">Transaction History</h5>
                     </div>
           
                     {transactionData.map((txItem, idx) => (
                       <div key={idx} className="mb-4">
                         <div className="badge bg-info mb-2">{formFieldDataP2.find((f: any) => f.fieldName === txItem.key)?.fieldLabel || txItem.key}</div>
           
                         {txItem.data.length === 0 ? (
                           <div className="text-muted">No transaction found.</div>
                         ) : (
                           txItem.data.map((entry, i) => (
                             <div
                               key={i}
                               className="border-start border-info border-3 p-3 mb-3 bg-light-subtle rounded"
                             >
                               <div className="d-flex justify-content-between align-items-center mb-2">
                                 <strong>Modified By:   {(() => {
                                                                     const role = roleOptions.find(
                                                                       (option) => option.value === entry.transactionBy
                                                                     );
                                                                   
                                                                     return role?.label || "Unknown";
                                                                   })()}</strong>
                                 <small className="text-muted">📅 {entry.createdAt || "-"}</small>
                               </div>
                          { entry.oldValue.length > 0 && entry.newValue.length > 0 &&    <div className="d-flex align-items-center gap-2 mb-2">
                                 <span className="text-danger">Old Data:</span>
                                 <div className="d-flex flex-column gap-1">
                                     {Array.isArray(entry.oldValue) ? (
                                       entry.oldValue.map((item, i) =>
                                         typeof item === "object" && item.fieldType === "doc" ? (
                                           <div key={i} className="d-flex align-items-center gap-2">
                                             <span className="badge bg-secondary">{responseMap[item?.fieldName]}</span>
                                             <Link
                                               to="#"
                                               data-bs-toggle="modal"
                                               data-inert={true}
                                               data-bs-target="#apmc_modal"
                                               className="btn btn-sm btn-outline-primary"
                                               onClick={() => setSelectedDocId(item.fieldValue)}
                                             >
                                               <i className="ti ti-eye"></i> View Document
                                             </Link>
                                           </div>
                                         ) : (
                                           <span key={i} className="badge bg-danger-subtle text-danger">
                                             {typeof item === "object" ? item.fieldValue : item}
                                           </span>
                                         )
                                       )
                                     ) : (
                                       <span className="badge bg-danger-subtle text-danger">{entry.oldValue.fieldValue}</span>
                                     )}
                                   </div>
                                 <i className="ti ti-arrow-right"></i>
                                 <span className="text-danger">Updated Data:</span>
           
                                  <div className="d-flex flex-column gap-1">
                                     {Array.isArray(entry.newValue) ? (
                                       entry.newValue.map((item, i) =>
                                         typeof item === "object" && item.fieldType === "doc" ? (
                                           <div key={i} className="d-flex align-items-center gap-2">
                                             <span className="badge bg-success">{responseMap[item?.fieldName]}</span>
                                             <Link
                                               to="#"
                                               data-bs-toggle="modal"
                                               data-inert={true}
                                               data-bs-target="#apmc_modal"
                                               className="btn btn-sm btn-outline-primary"
                                               onClick={() => setSelectedDocId(item.fieldValue)}
                                             >
                                               <i className="ti ti-eye"></i> View Document
                                             </Link>
                                           </div>
                                         ) : (
                                           <span key={i} className="badge bg-danger-subtle text-danger">
                                             {typeof item === "object" ? item.fieldValue : item}
                                           </span>
                                         )
                                       )
                                     ) : (
                                       <span className="badge bg-danger-subtle text-danger">{entry.newValue.fieldValue}</span>
                                     )}
                                   </div>
                               </div>}
                               <div className="d-flex align-items-center gap-2 mb-2">
                                 <span className="text-muted">Status:</span>
                                 <span className="badge bg-warning-subtle text-dark fs-14">
                                   {entry.status}
                                 </span>
                               </div>
                                 {/* Show verification status if available */}
                    {entry.isVerified !== undefined && (
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <span className="text-muted">Verified:</span>
                        <span className={`badge ${entry.isVerified ? 'bg-success' : 'bg-secondary'}`}>
                          {entry.isVerified ? 'Yes' : 'No'}
                        </span>
                      </div>
                    )}
                               {entry.comment && (
                                 <div className="bg-primary-subtle text-dark rounded p-2 d-flex align-items-start gap-2">
                                   <i className="ti ti-message mt-1"></i>
                                   <span>{entry.comment}</span>
                                 </div>
                               )}
                             </div>
                           ))
                         )}
                       </div>
                     ))}
                   </div>
                 )}
               </div>
             </div>
           )}
      <SingleView docId={selectedDocId} type="scheme"/>

    </>
  )
}
 
export default DistP2